import { Component, EventEmitter, Input, Output } from '@angular/core';


import { BehaviorSubject } from 'rxjs';
import { LibIcons } from '../../constants/global.constant';
import { WidgetsComingSoon } from '../../shared/shared.interface';
import { KngLoaderState } from '../loader';
import {
	KngCountOfItemCardData,
	KngCountOfItemCardDataState
} from './definitions';
import { KngCountOfItemCardFactory } from './kng-count-of-item-card.factory';

@Component({
	selector: 'kng-count-of-item-card',
	templateUrl: './template/kng-count-of-item-card.component.html',
	styleUrls: ['./template/kng-count-of-item-card.component.scss']
})
export class KngCountOfItemCardComponent implements KngCountOfItemCardData
{
	private state$: BehaviorSubject<KngCountOfItemCardDataState | undefined> =
		new BehaviorSubject<KngCountOfItemCardDataState|undefined>(
			KngCountOfItemCardFactory.buildState()
		);
    @Output() tooltipClicked: EventEmitter<void> =
    	new EventEmitter<void>();
  @Input() set state(value: KngCountOfItemCardDataState | undefined) 
    {
    	this.state$.next(value);
    }
  get state(): KngCountOfItemCardDataState | undefined
  {
  	return this.state$.value;
  }
  loaderState: KngLoaderState = {
  	imagePath: LibIcons.widgetLoader
  };

  comingSoon:WidgetsComingSoon = {
  	imagePath: '/assets/widgetsComingSoon.png',
  	imageText: 'Coming Soon',
  	title: 'Financed Equipment'
  };

  showTooltip()
  {
	  this.tooltipClicked.emit();
  }
  
}
